export default __webpack_public_path__ + "static/tasterkit-93a367657cafce09ce42ef15cbdb6298.png";